import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useTranslation } from '@crehana/i18n';
import { useListManager } from "../list-actions-layout";
import locales from "./i18n";
import { SegmentationFieldInput } from "./segmentation-field";
import { jsx as _jsx } from "react/jsx-runtime";
export function SegmentationFieldGroup(_ref) {
  var onCategorySelect = _ref.onCategorySelect,
    categories = _ref.categories,
    onFieldSelect = _ref.onFieldSelect,
    onChange = _ref.onChange,
    _ref$defaultValues = _ref.defaultValues,
    defaultValues = _ref$defaultValues === void 0 ? [] : _ref$defaultValues,
    onViewAffectedUsers = _ref.onViewAffectedUsers;
  var _useTranslation = useTranslation(),
    languageCode = _useTranslation.languageCode;
  var _useListManager = useListManager({
      onChange: onChange,
      defaultValues: defaultValues
    }),
    _useListManager2 = _slicedToArray(_useListManager, 2),
    ListActionsLayout = _useListManager2[0],
    listProps = _useListManager2[1];
  return /*#__PURE__*/_jsx(ListActionsLayout, _objectSpread(_objectSpread({}, listProps), {}, {
    footerActions: /*#__PURE__*/_jsx("button", {
      type: "button",
      className: "tw-mt-2.4 tw-btn-tertiary-xs disabled:tw-pointer-events-none disabled:tw-opacity-50",
      onClick: onViewAffectedUsers,
      disabled: !listProps.canDeleteAll,
      children: locales[languageCode].VIEW_USERS_IN_SEGMENT
    }),
    children: function children(_ref2) {
      var onItemChange = _ref2.onChange,
        onDelete = _ref2.onDelete,
        defaultValue = _ref2.defaultValue;
      return /*#__PURE__*/_jsx(SegmentationFieldInput, {
        onCategorySelect: onCategorySelect,
        categories: categories,
        onFieldSelect: onFieldSelect,
        onChange: onItemChange,
        onDelete: onDelete,
        defaultValue: defaultValue
      });
    }
  }));
}